import { useQuery } from 'react-query';

import { LocationService } from 'services';

export const useGetLocations = () =>
  useQuery('locations', LocationService.getLocations);
